import PatientObjectBaseProvider from "./patientObjectBaseProvider";

export default class PatientOverviewProvider extends PatientObjectBaseProvider {
	constructor($http, patientProvider, storage, eventBus) {
		super("patientOverview", $http, patientProvider, storage, eventBus);
	}
}
